// 维修列表
import request from "@/utils/request";

// 维修列表 /assetsRepair/admin/page
export function assetsRepairPage(data) {
  return request({
    url: "/assetsRepair/admin/page",
    method: "post",
    data
  });
}

// 维修记录的导出 /assetsRepair/admin/export
export function assetsRepairExport(data) {
  return request({
    url: "/assetsRepair/admin/export",
    method: "post",
    data,
    responseType: "blob"
  });
}